import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse, LockUserType } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useLockIraUser = () => {
  const queryClient = useQueryClient();

  const mutate = async ({ id, payload }: LockUserType) => {
    const { data } = await api.lockIraUser(id, payload);

    return data;
  };

  const mutationKey = MutationKeys.lockIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, LockUserType>(
    mutationKey,
    mutate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.iraUsers);
        queryClient.invalidateQueries(QueryKeys.iraUser);
      },
    },
  );
};
